export default __webpack_public_path__ + "static/media/47.4f16a567.png";